import { ApiModule } from '../../api/services';

export class TranslationsApi extends ApiModule {
  public loadTranslations(lang: string) {
    return this.api.get(`/lang/short/${lang}.json`);
  }
}
